import Brand from "~/components/brand";
import { useHeader } from "./header.context";
import { BurgerIcon } from "./icons";


export default function MenuBar() {
  const { setBurger } = useHeader();

  return (
    <div className="flex h-full w-full max-w-xl items-center justify-between px-2 md:hidden">
      <Brand />
      <button onClick={() => setBurger(true)}>
        <div
          aria-label="burgur menu"
          tabIndex={0}
          role="button"
          className="btn btn-soft border-none bg-transparent"
        >
          <BurgerIcon />
        </div>
      </button>
    </div>
  )
}
